export default "__VITE_ASSET__BvuMGcWW__"